import * as React from 'react';

function SvgPlayCircleFilled(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 25 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M22.343 12c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10zm-12.164 3.655a.72.72 0 00.729-.01l5.052-3.024a.733.733 0 000-1.243l-5.052-3.024a.716.716 0 00-.729-.009.8.8 0 00-.396.7v5.91c0 .292.152.561.396.7z", clipRule: "evenodd" })));
}

export default SvgPlayCircleFilled;
